import styled from "styled-components";

import { AppearFromBottom } from "../../../global/style";

const QuickLinksWrapper = styled(AppearFromBottom)`
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  flex-flow: row wrap;
  align-content: space-between;
  justify-content: center;
  gap : 10px;
  padding: 0 20px;
  margin-bottom: 12px;

  @media screen and (min-width: ${(prop) => prop.theme.screenSizes.breakSmall}) {
    // ${({ specials, hasImageQuickLinks }) => !specials && !hasImageQuickLinks && `padding-left: 28px;`}
    ${({ specials, hasImageQuickLinks }) => !specials && hasImageQuickLinks && `
      padding-left: 70px;
      justify-content: flex-start;
    `}

    grid-gap: 10px 10px;
  }

  @media screen and (min-width: ${(prop) => prop.theme.screenSizes.breakLaptop}) {
    justify-content: flex-start;
    ${({ specials }) => !specials && `padding-left: 187px;`}
  }
`;

const BackQuickLinkWrapper = styled(AppearFromBottom)`
  display: flex;
  padding: 0 20px;

  ${({ specials }) => !specials && `padding-left: 18px;`};

  @media screen and (min-width: ${(prop) => prop.theme.screenSizes.breakSmall}) {
    ${({ specials }) => !specials && `padding-left: 70px;`};
  }

  @media screen and (min-width: ${(prop) => prop.theme.screenSizes.breakLaptop}) {
    ${({ specials }) => !specials && `padding-left: 187px;`};
  }
`;
const NextQuickLinkWrapper = styled(AppearFromBottom)`
  display: flex;

  ${({ specials }) => !specials && `padding-left: 11px;`};

  @media screen and (min-width: ${(prop) => prop.theme.screenSizes.breakSmall}) {
    ${({ specials }) => !specials && `padding-left: 95px;`};
  }

  @media screen and (min-width: ${(prop) => prop.theme.screenSizes.breakLaptop}) {
    ${({ specials }) => !specials && `padding-left: 187px;`};
  }
`;

export {
  QuickLinksWrapper,
  BackQuickLinkWrapper,
  NextQuickLinkWrapper
}
